import React from 'react';
import FirstSection from './FirstSection';
import Commitments from './Commitments';
import Typhoon from './Typhoon';
import KeyMessages from './KeyMessages';
import ImageConverter from './ImageConverter';

const Main = () => {
  return (
    <main>
      <FirstSection />
      <Commitments />
      <Typhoon />
      <KeyMessages />
    </main>
  );
};

export default Main;
